import { render, staticRenderFns } from "./cross_city_person.vue?vue&type=template&id=2257a88c&scoped=true&"
import script from "./cross_city_person.vue?vue&type=script&lang=js&"
export * from "./cross_city_person.vue?vue&type=script&lang=js&"
import style0 from "./cross_city_person.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2257a88c",
  null
  
)

export default component.exports